import { render, staticRenderFns } from "./content-editor.vue?vue&type=template&id=0830ae3b"
import script from "./content-editor.vue?vue&type=script&lang=js"
export * from "./content-editor.vue?vue&type=script&lang=js"
import style0 from "./content-editor.vue?vue&type=style&index=0&id=0830ae3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports